import React, { useState } from "react";
import {
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
} from "reactstrap";


import classnames from "classnames";
import InvoicesTab from "./Tabs/InvoicesTab";
import AccountingTab from "./Tabs/AccountingTab";

const PartnerTabs = (props) => {
  const { form, disabled, setFormState } = props;
  const [customActiveTab, setcustomActiveTab] = useState("1");

  function toggleCustom(tab) {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  }

  return (
    <Col lg={12} className="mt-1">
      <Nav tabs className="nav-tabs-custom">
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: customActiveTab === "1",
            })}
            onClick={() => {
              toggleCustom("1");
            }}
          >
            <span className="d-sm-block">Facturación</span>
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({
              active: customActiveTab === "2",
            })}
            onClick={() => {
              toggleCustom("2");
            }}
          >
            <span className="d-sm-block">Contabilidad</span>
          </NavLink>
        </NavItem>
        
      </Nav>

      <TabContent activeTab={customActiveTab}>
        <InvoicesTab form={form} disabled={disabled} setFormState={setFormState} />
        <AccountingTab form={form} disabled={disabled} />
      </TabContent>
    </Col>
  );
};

export default PartnerTabs;
